// Utilitários para formatação de datas

/**
 * Formata uma data recebida do servidor para exibição
 * @param {string|Date} value - Valor da data do servidor
 * @returns {string} Data formatada em DD/MM/YYYY ou string vazia se inválida
 */
export const formatDate = (value) => {
  if (!value) return '';
  
  try {
    // Se for uma string de data MySQL (YYYY-MM-DD)
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
      const [year, month, day] = value.split('T')[0].split('-');
      return `${day}/${month}/${year}`;
    }
    
    // Para outros formatos - ajustar fuso horário
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';
    
    // Criar data ajustada para evitar problemas de fuso horário
    const adjustedDate = new Date(d.getTime() + d.getTimezoneOffset() * 60000);
    return adjustedDate.toLocaleDateString('pt-BR');
  } catch (error) {
    console.log('Erro ao formatar data:', value, error);
    return '';
  }
};

/**
 * Formata uma data e hora recebida do servidor para exibição
 * @param {string|Date} value - Valor da data/hora do servidor
 * @returns {string} Data e hora formatada em DD/MM/YYYY HH:MM ou string vazia se inválida
 */
export const formatDateTime = (value) => {
  if (!value) return '';
  
  try {
    // Para datas do banco no formato "YYYY-MM-DD HH:mm:ss"
    if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
      const [datePart, timePart] = value.split(' ');
      const [year, month, day] = datePart.split('-');
      const [hour, minute] = timePart.split(':');
      
      // Cria a data diretamente sem problemas de fuso horário
      const dataObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(minute));
      
      return dataObj.toLocaleString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    // Para outros formatos
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    
    // Criar data ajustada para evitar problemas de fuso horário
    const adjustedDate = new Date(d.getTime() + d.getTimezoneOffset() * 60000);
    return adjustedDate.toLocaleDateString('pt-BR') + ' ' + adjustedDate.toLocaleTimeString('pt-BR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  } catch (error) {
    console.log('Erro ao formatar data/hora:', value, error);
    return '';
  }
};

/**
 * Converte uma data no formato DD/MM/YYYY para YYYY-MM-DD (formato MySQL)
 * @param {string} dateStr - Data no formato DD/MM/YYYY
 * @returns {string} Data no formato YYYY-MM-DD ou string vazia se inválida
 */
export const formatDateForDatabase = (dateStr) => {
  if (!dateStr) return '';
  
  try {
    const [day, month, year] = dateStr.split('/');
    if (!day || !month || !year) return '';
    
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  } catch (error) {
    console.log('Erro ao formatar data para banco:', dateStr, error);
    return '';
  }
};

/**
 * Verifica se uma string é uma data válida
 * @param {string} dateStr - String da data
 * @returns {boolean} True se for uma data válida
 */
export const isValidDate = (dateStr) => {
  if (!dateStr) return false;
  
  try {
    const d = new Date(dateStr);
    return !isNaN(d.getTime());
  } catch (error) {
    return false;
  }
};
